import React from "react";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useAtom } from "jotai";

export const SwitchControl = ({ atom, label, name }) => {
    const [value, setValue] = useAtom(atom);

    const handleChange = (event) => {
        setValue(event.target.checked);
    };

    return (
        <FormControlLabel
            control={
                <Switch
                    checked={value}
                    onChange={handleChange}
                    name={name}
                    size="small"
                />
            }
            label={label}
            sx={{
                padding: "4px",
                margin: "4px",
                "& .MuiTypography-root": {
                    fontSize: "14px"
                }
            }}
        />
    );
};
